<template>
  <vx-card v-show="isCardActiveLocal" title="Video Capture Task Details" class="mb-4" id="CaptureTaskView">
    <div class="vx-row">
      <div class="vx-col w-full">
        <table>
          <tr><td><p>Title:</p></td><td><p style="font-weight: 700">{{ captureTaskTitle }}</p></td></tr>
          <tr><td><p>Description:</p></td><td><p style="font-weight: 700">{{ captureTaskDescription }}</p></td></tr>
        </table>
      </div>
    </div>
    <vs-divider></vs-divider>
    <h5 class="mt-4 mb-3">Captured/Uploaded File</h5>
    <vs-table ref="uploadsTable" single max-items="15" @selected="open" pagination :data="this.captureTask.uploadedFiles">
      <div slot="header" class="mt-4 mb-3 flex flex-wrap-reverse items-center flex-grow justify-between">
        <div class="flex flex-wrap-reverse items-center">
        </div>
      </div>
      <template slot-scope="{data}">
        <vs-tr :data="file" :key="indextr" v-for="(file, indextr) in data">
          <vs-td>
            <img :src="setFileThumb(file)" width=30px class="product-img" style="filter: contrast(0.5);"/>
          </vs-td>
          <vs-td>
            <p class="product-name font-medium">{{ file.substring(file.lastIndexOf('/') + 1) }}</p>
          </vs-td>
        </vs-tr>
      </template>
    </vs-table>
    <div v-if="!viewOnly">
      <vs-divider></vs-divider>
      <div v-html="captureTask.description" :style="{ 'font-size': '16pt'}"></div>
      <div :style="{'text-align' : 'center', 'overflow':'hide'}">
        <iframe id="videocaptureFrame" :src="videoCaptureIframeUrl" frameborder="0" allowfullscreen="true" mozallowfullscreen="true" webkitallowfullscreen="true" allow="microphone; camera" style="width:50%; height:100%; overflow: hidden" ></iframe>
      </div>
      <vs-divider>OR</vs-divider>
      <div class="vx-row">
        <div class="vx-col w-full mx-auto  self-center">
          <file-pond
            v-show="true"
            id="cover-filepond"
            ref="newUploadPond"
            allowPaste=false
            :server="uploadLocation"
            label-idle="Upload new video here"
            accepted-file-types="video/mp4"
            :allow-multiple="false"
            :allow-image-preview="false"
            :instant-upload="true"
            @processfile="uploadComplete"
            @removefile="fileRemoved"
          />
        </div>
      </div>
    </div>
  </vx-card>
</template>

<script>
  import 'quill/dist/quill.core.css';
  import 'quill/dist/quill.snow.css';
  import 'quill/dist/quill.bubble.css';
  import { quillEditor } from 'vue-quill-editor';
  import Player from '@vimeo/player'

  import Plyr from 'plyr';
  import 'plyr/dist/plyr.css';

  import { setTimeout, setInterval } from 'timers';
  import { uuid } from 'vue-uuid';
  import { WebCam } from 'vue-web-cam';

  import vSelect from 'vue-select'
  import vueFilePond from 'vue-filepond';
  import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
  import FilePondPluginImagePreview from 'filepond-plugin-image-preview';
  const FilePond = vueFilePond(FilePondPluginFileValidateType, FilePondPluginImagePreview);
  
  export default {
    components: {
      'v-select': vSelect,
      FilePond,
      WebCam,
      quillEditor,
      Plyr
    },
    props: {
      isCardActive: {
        type: Boolean,
        required: true
      },
      captureTask: {
        type: Object,
        required: false
      },
      viewOnly: {
        type: Boolean,
        required: false
      }
    },
    data() {
      return {
        captureTaskTitle: "",
        captureTaskDescription: "",
        videoCaptureIframeUrl: "",
        backgroundCardWidth: "",       
        descriptionFontSize: "",
        backgroundCardHeight: "",
        videoCaptureUrl: "",
        messageType: "",
      }
    },
    computed: {
      isCardActiveLocal: {
        get() {
          return this.isCardActive;
        },
        set(val) {
          if (!val) {
            this.$emit("closeCard");
            this.initValues();
          }
        }
      }, 
      uploadLocation: {
        get() {
          return this.$buildUrl("tempupload");
        }
      },
    },
    watch: {
      isCardActive: function(val) {
        if(val){
          var self = this;
          if(self.captureTask){

          }else{
            self.initValues();
          }
        }
      }
    },
    methods: {
      strip(html){
        var doc = new DOMParser().parseFromString(html, 'text/html');
        return doc.body.textContent || "";
      },
      setColor(val) {
        if(val){
          return '#00cc00';
        }
        else{
          return 'orange';
        }
      },
      open(file){
        window.open(file);
      },
      saveData() {
        this.initValues();
        this.$emit('saveData');
      },
      initValues() {        
        this.errors.clear();
      },
      uploadComplete(error, file) {
        var self = this;
        var response = JSON.parse(file.serverId);

        if(Object.keys(self.captureTask.newUploadedFiles).length == 0){
            self.captureTask.newUploadedFiles.push(response.url);

            self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Video Saved",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-video',
            });  
          }
          else{
            self.captureTask.newUploadedFiles = [];
            self.captureTask.newUploadedFiles.push(response.url);

            self.$vs.notify({
            title:'Information',
            color: "success",
            text: "New Video Saved",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-video',
            });  
          }    
      },
      fileRemoved(error, file) {
        var self = this;
        this.captureTask.newUploadedFiles = [];

        if(self.videoCaptureUrl != ""){
          self.captureTask.newUploadedFiles.push(self.videoCaptureUrl);
        }
        
        self.$vs.notify({
          title:'Information',
          color: "warning",
          text: "Uploaded Video Removed",
          position:'top-right',
          iconPack: 'feather',
          icon:'icon-video',
          });  
      },
      scrollToNavbar() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -500,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("navbarGlobal"), 500, scrollOptions);
      },
      scrollToFooter() {
        var scrollOptions = {
          easing: 'ease-in',
          offset: -480,
          force: true,
          cancelable: true,
          x: false,
          y: true
        }
        var cancelScroll = this.$scrollTo(document.getElementById("footerGlobal"), 100, scrollOptions);
      },
      setFileThumb(url) {
        var ext = url.substring(url.lastIndexOf('.') + 1);
        if (ext.includes('mp3'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/music.jpg";
        else if (ext.includes('jpg') || ext.includes('jpeg') || ext.includes('png') || ext.includes('gif'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/image.png";
        else if (ext.includes('doc') || ext.includes('xls') || ext.includes('pdf') || ext.includes('ppt') || ext.includes('txt') || ext.includes('rtf'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/document.png";
        else if (ext.includes('mp4') || ext.includes('wmv') || ext.includes('mov') || ext.includes('webm') || ext.includes('x-matroska') || ext.includes('mkv'))
          return "https://forty5degreesstorage.blob.core.windows.net/assets/video.png";
      },
    },
    mounted() {
      if(this.captureTask){
        self = this;
        self.captureTaskTitle = this.strip(this.captureTask.title);
        self.captureTaskDescription = this.strip(this.captureTask.description);
        self.videoCaptureIframeUrl = self.$VUE_APP_VIDEO_CAPTURE_URL + "&t=" + new Date().getTime();
      }
      window.addEventListener("message", function () {
        if (event.data.message == 'iFrame') {
          self.videoCaptureUrl = event.data.results.link;
          self.messageType = "recordType";

          if(Object.keys(self.captureTask.newUploadedFiles).length == 0){
            self.captureTask.newUploadedFiles.push(self.videoCaptureUrl);

            self.$vs.notify({
            title:'Information',
            color: "success",
            text: "Video Saved",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-video',
            });  
          }
          else{
            self.captureTask.newUploadedFiles = [];
            self.captureTask.newUploadedFiles.push(self.videoCaptureUrl);

            self.$vs.notify({
            title:'Information',
            color: "success",
            text: "New Video Saved",
            position:'top-right',
            iconPack: 'feather',
            icon:'icon-video',
            });  
          }            
        }
      }, false);
    }
  }

</script>

<style lang="scss">
.table-class {
  border: solid;
  border-width: thin;
  border-color: rgb(248, 248, 248);
 }

.table-class:hover {
  transform: translate(0px, -3px);
}
</style>
